module.exports = __webpack_public_path__ + "static/media/returnInvest.2cd8ee40.png";